import { forwardRef, useCallback } from "react";

import { ActionIcon, ActionIconProps, Loader } from "@mantine/core";
import { IconDownload, TablerIconsProps } from "@tabler/icons-react";

import { useCountEvent } from "../../hooks/useCountEvent";
import { useDownloadPDF } from "../../hooks/useDownloadPDF";
import { serializedChecklistDocument } from "../../lib/state/convert";
import { store } from "../../lib/state/store";

type Props = ActionIconProps & { iconSize: TablerIconsProps["size"]; libraryIndex?: number };

export const PDFDownloadButton = forwardRef<HTMLButtonElement, Props>(
  (props: Props, ref): JSX.Element => {
    const { iconSize, libraryIndex, ...actionIconProps } = props;

    const { download: downloadDocumentPdf, isLoading } = useDownloadPDF();

    const countEvent = useCountEvent();
    const onClick = useCallback(() => {
      if (isLoading) return;

      const editingIndex = libraryIndex ?? store.getState().library.editingEntry;
      if (editingIndex !== null) {
        const currentDocument = store.getState().library.entries[editingIndex].present;
        const serializedDocument = serializedChecklistDocument(currentDocument);
        downloadDocumentPdf(serializedDocument);
        countEvent("download-pdf");
      }
    }, [isLoading, downloadDocumentPdf, countEvent, libraryIndex]);

    return (
      <ActionIcon {...actionIconProps} onClick={onClick} ref={ref} disabled={isLoading}>
        {isLoading ? <Loader size="sm" /> : <IconDownload size={iconSize} />}
      </ActionIcon>
    );
  }
);
